/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

interface MainNavItemArgsInterface {
  routeName: string;
  title: string;
  icon?: string;
  query?: string;
  currentWhen?: boolean;
}

// Require model or models
type MainNavItemArgs = MainNavItemArgsInterface & ({ model: unknown } | { models: unknown });

export default class MainNavItemComponent extends Component<MainNavItemArgs> {}
